// src/services/EmployeeService.js
//
// Calls to Vero's own backend. Authentication is handled by apiClient, which
// attaches the Entra access token to every request.

import apiClient from './apiClient'

// The backend expects two letter country codes (matches the CHAR(2)
// country_code columns), not full country names.
export const COUNTRY = {
  DENMARK: 'DK',
  SINGAPORE: 'SG',
  US: 'US'
}

export default {
  getDepartmentNames(country) {
    return apiClient.post('/GetDepartmentsAndNamesForCountry', { country })
  },

  getDepartmentsAndMembers(country) {
    return apiClient.post('/GetDepartmentsAndMembersForCountry', { country })
  },

  getLocationsAndDoors(country) {
    return apiClient.post('/GetLocationsAndDoorsForCountry', { country })
  },

  getAssignableRoles() {
    return apiClient.get('/GetUserAssignableRoles')
  }
}
